import { createEffect, createEvent, sample } from 'effector'

import { attachI18n } from '@/shared/lib/i18n'
import { toast } from '@/shared/lib/toast'

export const supportIDClicked = createEvent<string>()

const copyToClipboardFx = createEffect((text: string) => navigator.clipboard.writeText(text))

sample({
    clock: supportIDClicked,
    target: copyToClipboardFx,
})

sample({
    clock: copyToClipboardFx.done,
    target: attachI18n(toast.successFx, 'ID_COPIED'),
})
